import React from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Button,
  Badge,
  NavItem,
  NavLink,
} from "reactstrap";
import { IAccount } from "../../../../../../marketing/Chat/types";

interface ContaSocialProps {
  disabled?: boolean;
  setTabActive: () => void;
  title: string;
  icon: string;
  isConnected?: boolean;
  accounts?: IAccount[];
  type?: "email" | "phone" | "portais";
  name?: string;
}

export default function ContaSocialCard({
  disabled,
  setTabActive,
  title,
  icon,
  isConnected = false,
  accounts,
  type,
}: ContaSocialProps) {
  const content = () => {
    const count = accounts?.length ?? 0;
    const countActive = accounts?.filter((a) => a.situacao === "A").length ?? 0;
    if (count > 0) {
      const hasActivePhone =
        type === "phone" && accounts!.some((a) => a.situacao === "A");
      return (
        <>
          <Badge pill color="success">
            {count}
            {type === "email" && " email(s) conectado(s) "}
            {type === "phone" && " cadastrado(s) "}
            {hasActivePhone && `${countActive} conectado(s)`}
            {type === "portais" && " portal(s) conectado(s)"}
          </Badge>
          <Button size="sm" onClick={setTabActive} color="info">
            Detalhes
          </Button>
        </>
      );
    } else {
      return (
        <>
          {!isConnected && (
            <Badge pill color="warning">
              Desconectado
            </Badge>
          )}
          {!isConnected && (
            <Button size="sm" onClick={setTabActive} color="primary">
              Conectar
            </Button>
          )}
          {isConnected && (
            <Badge pill color="success">
              Conectado
            </Badge>
          )}
          {isConnected && (
            <Button size="sm" onClick={setTabActive} color="info">
              Detalhes
            </Button>
          )}
        </>
      );
    }
  };

  return (
    <NavItem style={{ width: "100%" }}>
      <NavLink
        href="#"
        role="tab"
        disabled={disabled}
        style={{ cursor: "default" }}
      >
        <Card className="d-relative">
          <div style={{ top: "8px", right: "8px", position: "absolute" }}>
            <span>
              <i className="fas fa-info-circle"></i>
            </span>
          </div>
          <CardBody
            className="d-flex flex-column align-items-center"
            style={{ gap: "10px" }}
          >
            <div>
              <span style={{ fontSize: "3rem" }}>
                <i className={icon}></i>
              </span>
            </div>
            <CardTitle tag="h4">{title}</CardTitle>
            {content()}
          </CardBody>
        </Card>
      </NavLink>
    </NavItem>
  );
}
